import {ChartType, FiltersOperator} from 'common/types/reports/bookmark';

import type {BookmarkYAxisOptions, FilterDeterminer} from './types';

export const OTHER_SEGMENT_VALUE = `$other_segment`;

export const ChartResultChartTypes = [
  ChartType.Line,
  ChartType.StackedLine,
  ChartType.Bar,
  ChartType.StackedBar,
  ChartType.Pie,
  ChartType.Table,
  ChartType.Metric,
];

export const FILTER_DETERMINER_ALL: FilterDeterminer = `all`;
export const FILTER_DETERMINER_ANY: FilterDeterminer = `any`;

export const DETERMINER_MAPPING = {
  [FiltersOperator.And]: FILTER_DETERMINER_ALL,
  [FiltersOperator.Or]: FILTER_DETERMINER_ANY,
};

export enum QueryMode {
  Events = `Events`,
  Groups = `Profiles`,
  Funnels = `Funnels`,
  Retention = `Retention`,
}

// NOTE: This can't just be an empty object because the way we call Lodash.mergeWith
// it will overwrite existing values with `undefined` if each value is explicitly
// `undefined`.
export const EMPTY_BOOKMARK_Y_AXIS_OPTIONS: BookmarkYAxisOptions = {
  axisUnit: undefined,
  labels: undefined,
  min: undefined,
  max: undefined,
  title: undefined,
  type: undefined,
  useSoftMinMax: undefined,
};

export const INSIGHTS_METRICS_LIMIT_OVERRIDES = {
  2354103: 40, // TODO: Remove after 3/1/26
  2462203: 80, // TODO: Remove after 4/1/26
  2785969: 80, // TODO: Remove after 4/1/26
  1952195: 130, // TODO: Remove after 5/1/26
};

export const DURATION_PROPERTY_NAME = `$page_duration`;

export const NUMERIC_DATA_PRECISION = 8;
